import type { Scorecard } from "../types/analysis";

type VsKey = keyof NonNullable<Scorecard["v7_scores"]>;

export interface SubMetricDef {
  label: string;
  scoreKey: VsKey;
  /** Must match the display name in blueprint ``sections.summary`` markdown. */
  summaryKey: string;
}

export interface PillarDef {
  id: string;
  title: string;
  scoreKey: VsKey;
  subMetrics: SubMetricDef[];
}

export const SCORECARD_PILLARS: PillarDef[] = [
  {
    id: "story_spine",
    title: "Story Spine",
    scoreKey: "story_spine_pct",
    subMetrics: [
      { label: "Story Strength", scoreKey: "etb_structure_pct", summaryKey: "Story Strength" },
      { label: "Pacing", scoreKey: "pacing_pct", summaryKey: "Pacing" },
      { label: "Story Beat Strength", scoreKey: "story_beat_strength_pct", summaryKey: "Story Beat Strength" },
      { label: "Scene Strength", scoreKey: "scene_strength_pct", summaryKey: "Scene Strength" },
      {
        label: "Concentration of Overarching Problem",
        scoreKey: "concentration_pct",
        summaryKey: "Concentration of Overarching Problem",
      },
    ],
  },
  {
    id: "character_strength",
    title: "Character Strength",
    scoreKey: "character_strength_pct",
    subMetrics: [
      { label: "Character Concentration", scoreKey: "character_concentration_pct", summaryKey: "Character Concentration" },
      { label: "Character Resonance", scoreKey: "character_resonance_pct", summaryKey: "Character Resonance" },
      { label: "Character Active Metre", scoreKey: "character_active_pct", summaryKey: "Character Active Metre" },
      { label: "Dialogue Strength", scoreKey: "dialogue_strength_pct", summaryKey: "Dialogue Strength" },
      { label: "Character Journey", scoreKey: "character_journey_pct", summaryKey: "Character Journey" },
    ],
  },
  {
    id: "theme_strength",
    title: "Theme Strength",
    scoreKey: "theme_strength_pct",
    subMetrics: [
      { label: "Thematic Quality", scoreKey: "thematic_quality_pct", summaryKey: "Thematic Quality" },
      { label: "Authenticity Score", scoreKey: "authenticity_pct", summaryKey: "Authenticity Score" },
      { label: "Genre Promise", scoreKey: "genre_promise_pct", summaryKey: "Genre Promise" },
    ],
  },
  {
    id: "commercial_viability",
    title: "Commercial Viability",
    scoreKey: "commercial_viability_pct",
    subMetrics: [
      { label: "Originality Metre", scoreKey: "originality_pct", summaryKey: "Originality Metre" },
      { label: "Target Market", scoreKey: "target_market_pct", summaryKey: "Target Market" },
    ],
  },
];
